<div [ngClass]="'tree-div-' + deepness">
  @for (article of articles; track article) {
    <div class="ps-2 ms-2" [class.not-read]="!article.read">
      <span class="d-flex align-items-center gap-1">
        <a class="d-inline d-xl-none" [href]="'/documentation/' + article.id" (click)="downloadFile($event, article.id, article, true)">
          <div class="ps-1 pe-1 me-2 read-indicator">Màj.</div>
          <fa-icon class="pe-2"
          [icon]="['far', getIconFromContentType(article.contentType)] //noinspection ValidateTypes"></fa-icon>
          {{ article.title }}
        </a>
        <a class="d-none d-xl-inline" [href]="'/documentations/' + article.id" (click)="downloadFile($event, article.id, article)">
          <div class="ps-1 pe-1 me-2 read-indicator">Màj.</div>
          <fa-icon class="pe-2"
          [icon]="['far', getIconFromContentType(article.contentType)] //noinspection ValidateTypes"></fa-icon>
          {{ article.title }}
        </a>
        @if (downloads[article.id] !== undefined) {
          <app-resource-download-indicator [percent]="downloads[article.id]"
          [radius]="8"></app-resource-download-indicator>
        }
      </span>
    </div>
  }

  @for (cat of categories; track cat) {
    <div class="ps-2 pt-2 ms-2" [ngClass]="cat.display ? 'with-border' : 'without-border'">
      <span (click)="cat.display = !cat.display" [class.not-read]="cat.read && !cat.display">
        <fa-icon [icon]="['far', cat.display ? 'minus-square' : 'plus-square']"></fa-icon>
        <span class="ps-1 cursor-pointer"> {{ cat.title }}</span>
        <div class="ps-1 pe-1 ms-2 read-indicator">Màj.</div>
      </span>
      <app-resources-tree [deepness]="deepness+1" class="ps-2"
        [showall]="$showAll"
        [hideall]="$hideAll"
        [hidden]="!cat.display"
        [search]="_search"
        [resources]="resources"
        [category]="(category ? category + SEPARATOR : '') + cat.title"
        (blob)="selectFile($event)"
        (loading)="onChildLoading($event)">
      </app-resources-tree>
    </div>
  }
</div>
